import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LookupModel } from '../../../../api/models/lookup-model';
import { EVENT_FLOW_FIELD_LABELS } from '../../node-parameters/constants/event-flow-field-labels.const';
import { MatTextInputComponent } from '../../../../editors/mat-text-input/mat-text-input.component';
import { MatSimpleSelectComponent } from '../../../../editors/mat-simple-select/mat-simple-select.component';
import { NgIf } from '@angular/common';
import { MatPasswordInputComponent } from '../../../../editors/mat-password-input/mat-password-input.component';

@Component({
    selector: 'events-flow-url-settings',
    templateUrl: './url-settings.component.html',
    styleUrls: ['./url-settings.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatTextInputComponent,
        MatSimpleSelectComponent,
        NgIf,
        MatPasswordInputComponent,
    ],
})
export class EventsFlowUrlSettingsComponent implements OnInit {
  @Input({ required: true })
  actionItemFormGroup!: FormGroup;

  public readonly httpMethods: LookupModel[] = [
    { id: 'GET', text: 'GET' },
    { id: 'POST', text: 'POST' },
    { id: 'PUT', text: 'PUT' },
  ];
  public readonly authMethods: LookupModel[] = [
    { id: 'none', text: 'None' },
    { id: 'basic', text: 'Basic' },
  ];

  public readonly fieldLabels = EVENT_FLOW_FIELD_LABELS;

  constructor() {}

  get isBasicAuth(): boolean {
    return this.actionItemFormGroup?.get('authMethod')?.getRawValue() === 'basic';
  }

  ngOnInit(): void {
    this.actionItemFormGroup?.markAllAsTouched();
  }

  public onAuthMethodChanged(): void {
    const authCredentialControls = [
      this.actionItemFormGroup?.get('authUsername'),
      this.actionItemFormGroup?.get('authPassword'),
    ];

    if (this.isBasicAuth) {
      authCredentialControls.forEach(control => {
        control.setValidators(Validators.required);
        control.markAsTouched();
      });
      return;
    }

    authCredentialControls.forEach(control => {
      control.clearValidators();
      control.reset();
    });
  }
}
